export default __webpack_public_path__ + "static/media/pic6.c8e86d3c.jpg";